import React, { useState } from "react";

//Component
import {
  DataGrid,
  GridColDef,
  GridColumns,
  GridToolbarContainer,
} from "@material-ui/data-grid";
import CustomLoadingOverlay from "components/DataGridLoadingOverlay";
import CustomNoRowsOverlay from "components/DataGridNoRowsOverlay";
import { ARIA_SuccessCode, Feature } from "models";
import { DataGridFilterToolbar } from "components/DataGridFilterToolbar";
import { GridColFilterDef } from "components/DataGridFilterSelection";
//Icon

//Helper
import { convertDateTimeToString } from "utils/dateHelper";
import { Data } from "react-csv/components/CommonPropTypes";
import { ExportButton } from "components/ExportButton";
import { MainDrawer } from "components/MainDrawer";
import { AccessControlButton, CodeMirrorTextField } from "components";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import {
  PM_ADD_FEATURE_CODE,
  PM_DELETE_FEATURE_CODE,
  PM_EDIT_FEATURE_CODE,
} from "models/backend/constant/PermissionCode";
import {
  createFeatureAPI,
  deleteFeatureAPI,
  getFeatureListAPI,
  updateFeatureAPI,
} from "services/featureService";

export const FeatureManagementScreen = () => {
  const [index, setIndex] = useState<number>(1);
  const [size, setSize] = useState<number>(10);
  const [row, setRow] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const [requestDateTime, setRequestDateTime] = useState<Date>(new Date());

  const [featureManagementList, setHotelGroupManagementList] = useState<
    Feature[]
  >([]);
  const [exportList, setExportList] = useState<Data>([]);
  const [filterList, setFilterList] = useState<GridColFilterDef[]>([]);

  const [loadList, setloadList] = useState(true);

  const [addFeature, setAddFeature] = useState<any | undefined>();
  const [editFeature, setEditFeature] = useState<Feature | undefined>();
  const [removeFeature, setRemoveFeature] = useState<Feature | undefined>();
  const [deleteConfirmation, setDeleteConfirmation] = useState("");

  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  //Setting up the each column header item
  const hotelGroupCodeHeader: GridColDef = {
    field: "description",
    headerName: "Description",
    sortable: false,
    renderHeader: (params: any) => <strong>{"Description"}</strong>,
    minWidth: 300,
    flex: 2,
  };

  const hotelGroupNameHeader: GridColDef = {
    field: "name",
    headerName: "Name",
    sortable: false,
    renderHeader: (params: any) => <strong>{"Name"}</strong>,
    minWidth: 200,
    flex: 1,
  };

  const actionsHeader: GridColDef = {
    field: "id",
    headerName: "Actions",
    minWidth: 240,
    filterable: false,
    sortable: false,
    disableColumnMenu: true,
    renderHeader: () => <strong>{"Actions"}</strong>,
    renderCell: (params: any) => (
      <strong>
        <AccessControlButton
          code={PM_EDIT_FEATURE_CODE}
          variant="contained"
          color="primary"
          size="small"
          value={params.value}
          onClick={handleOpenEditDialog}
        >
          Edit
        </AccessControlButton>
        <AccessControlButton
          code={PM_ADD_FEATURE_CODE}
          variant="contained"
          color="primary"
          size="small"
          value={params.value}
          style={{ marginLeft: 12 }}
          onClick={handleDuplicateFunctionClick}
        >
          Clone
        </AccessControlButton>
        <AccessControlButton
          code={PM_DELETE_FEATURE_CODE}
          variant="contained"
          color="primary"
          size="small"
          value={params.value}
          style={{ marginLeft: 12 }}
          onClick={handleOpenDeleteDialog}
        >
          Delete
        </AccessControlButton>
      </strong>
    ),
  };

  const headerColumn: GridColumns = [
    hotelGroupNameHeader,
    hotelGroupCodeHeader,
    actionsHeader,
  ];

  React.useEffect(() => {
    if (loadList) {
      setIsLoading(true);
      setHotelGroupManagementList([]);
      setRequestDateTime(new Date());

      getFeatureListAPI({
        filter: filterList,
        pageIndex: index,
        pageSize: size,
        // orderBy: "module",
      })
        .then((response) => {
          if (response.resultCode === ARIA_SuccessCode) {
            setHotelGroupManagementList(response.result.items);
            setRow(response.result.rowCount);
          }
        })
        .finally(() => {
          setloadList(false);
          setIsLoading(false);
        });
    }
  }, [index, size, filterList, loadList]);

  const getExportTransaction = async () => {
    setIsLoading(true);
    var _exportIndex = 1;
    var exportList: Feature[] = [];

    try {
      do {
        var response = await getFeatureListAPI({
          filter: filterList,
          pageIndex: _exportIndex,
          pageSize: size,
          //   orderBy: "module",
        });

        exportList.push(...response.result.items);

        _exportIndex++;
      } while (response.result.pageCount >= _exportIndex);

      setExportList(exportList);
      setIsExporting(true);
      setIsLoading(false);
    } catch (err) {
      console.log("Oposs.. Something is wrong");
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <DataGridFilterToolbar
          headerColumns={headerColumn}
          filterList={filterList}
          onFilterApply={(items) => {
            setFilterList(items.slice());
            setloadList(true);
          }}
        />
        <ExportButton
          filename="Feature"
          data={exportList}
          headers={[
            { label: "Name", key: "name" },
            { label: "Code", key: "code" },
          ]}
          readyToExport={isExporting}
          onClick={getExportTransaction}
          onFinishDownload={() => {
            setExportList([]);
            setIsExporting(false);
          }}
        >
          Export
        </ExportButton>
        <div style={{ flexGrow: 1 }}></div>
        <AccessControlButton
          code={PM_ADD_FEATURE_CODE}
          variant="contained"
          color="primary"
          size="small"
          onClick={handleOpenCreateDialog}
        >
          New Feature
        </AccessControlButton>
        <div style={{ paddingLeft: "8px" }}>
          <b>Data as at </b>: {convertDateTimeToString(requestDateTime)}
        </div>
      </GridToolbarContainer>
    );
  }

  const handleOpenCreateDialog = () => {
    setOpenEditDialog(true);
  };

  const handleDuplicateFunctionClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    var _updateFeature = featureManagementList.find(
      (f) => f.id === parseInt(event.currentTarget.value)
    );

    setAddFeature(_updateFeature);
    setOpenEditDialog(true);
  };

  const handleOpenEditDialog = (event: React.MouseEvent<HTMLButtonElement>) => {
    var _updateFeature = featureManagementList.find(
      (f) => f.id === parseInt(event.currentTarget.value)
    );

    if (_updateFeature != undefined) {
      setEditFeature(_updateFeature);
    }

    setOpenEditDialog(true);
  };

  const handleOpenDeleteDialog = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    var _removeHotelGroup = featureManagementList.find(
      (f) => f.id === parseInt(event.currentTarget.value)
    );
    setRemoveFeature(_removeHotelGroup);
    setOpenDeleteDialog(true);
  };

  const handleEditOrAdd = () => {
    if (editFeature == null) {
      if (
        addFeature === null ||
        addFeature.name === null ||
        addFeature.name === "" ||
        addFeature.code === null ||
        addFeature.code === "" ||
        addFeature.defaultConfig === null ||
        addFeature.defaultConfig === ""
      ) {
        alert("Please fill up the details below to add a new feature.");
      } else {
        createFeatureAPI({ ...addFeature })
          .catch((err) => {
            alert(err);
          })
          .finally(() => {
            setloadList(true);
            handleEditClose();
          });
      }
    } else {
      if (
        editFeature.name === null ||
        editFeature.name === "" ||
        editFeature.code === null ||
        editFeature.code === "" ||
        editFeature.defaultConfig === null ||
        editFeature.defaultConfig === ""
      ) {
        alert("Please fill up the details below to edit feature.");
      } else {
        try {
          updateFeatureAPI({
            ...editFeature,
            defaultConfig: JSON.stringify(
              JSON.parse(editFeature.defaultConfig)
            ),
          })
            .catch((err) => {
              alert(err);
            })
            .finally(() => {
              setloadList(true);
              handleEditClose();
            });
        } catch (err) {
          alert("JSON Syntax Error!!");
        }
      }
    }
  };

  const handleDelete = () => {
    if (deleteConfirmation !== removeFeature?.name) {
      alert("Please key in the feature name to confirm deletion.");
    } else {
      deleteFeatureAPI({ ...removeFeature })
        .catch((err) => {
          alert(err);
        })
        .finally(() => {
          setDeleteConfirmation("");
          setloadList(true);
          handleEditClose();
        });
    }
  };

  const handleEditClose = () => {
    setAddFeature(undefined);
    setEditFeature(undefined);
    setRemoveFeature(undefined);
    setOpenEditDialog(false);
    setOpenDeleteDialog(false);
  };

  return (
    <>
      <MainDrawer title="Feature Management">
        {/* Add and Edit Dialog */}
        <Dialog
          open={openEditDialog}
          onClose={handleEditClose}
          aria-labelledby="form-dialog-title"
          fullWidth
          maxWidth="lg"
        >
          <DialogTitle id="form-dialog-title">
            {editFeature != undefined ? "Edit Feature" : "Add Feature"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {editFeature != undefined
                ? "Change the detail below and save it to update feature details, ."
                : "Fill up the details below to add a new feature."}
            </DialogContentText>
            <form noValidate autoComplete="off">
              <div>
                <TextField
                  margin="dense"
                  id="name"
                  label="Feature Name"
                  type="text"
                  value={
                    editFeature != undefined
                      ? editFeature.name
                      : addFeature?.name != undefined
                      ? addFeature?.name
                      : ""
                  }
                  onChange={(e) => {
                    editFeature != undefined
                      ? setEditFeature({
                          ...editFeature,
                          name: e.currentTarget.value,
                        })
                      : setAddFeature({
                          ...addFeature,
                          name: e.currentTarget.value,
                        });
                  }}
                  fullWidth
                />
                <TextField
                  margin="dense"
                  id="code"
                  label="Code"
                  type="text"
                  value={
                    editFeature != undefined
                      ? editFeature.code
                      : addFeature?.code != undefined
                      ? addFeature?.code
                      : ""
                  }
                  onChange={(e) => {
                    editFeature != undefined
                      ? setEditFeature({
                          ...editFeature,
                          code: e.currentTarget.value,
                        })
                      : setAddFeature({
                          ...addFeature,
                          code: e.currentTarget.value,
                        });
                  }}
                  fullWidth
                />
                <TextField
                  margin="dense"
                  id="desc"
                  label="Description"
                  type="text"
                  multiline
                  value={
                    editFeature != undefined
                      ? editFeature.description
                      : addFeature?.description != undefined
                      ? addFeature?.description
                      : ""
                  }
                  onChange={(e) => {
                    editFeature != undefined
                      ? setEditFeature({
                          ...editFeature,
                          description: e.currentTarget.value,
                        })
                      : setAddFeature({
                          ...addFeature,
                          description: e.currentTarget.value,
                        });
                  }}
                  fullWidth
                />
                <CodeMirrorTextField
                  value={
                    editFeature != undefined
                      ? editFeature.defaultConfig
                      : addFeature?.defaultConfig != undefined
                      ? addFeature?.defaultConfig
                      : ""
                  }
                  onChange={(value) => {
                    editFeature != undefined
                      ? setEditFeature({
                          ...editFeature,
                          defaultConfig: value,
                        })
                      : setAddFeature({
                          ...addFeature,
                          defaultConfig: value,
                        });
                  }}
                />
              </div>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleEditClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleEditOrAdd} color="primary">
              {editFeature != null ? `Save & Update` : `Add Feature`}
            </Button>
          </DialogActions>
        </Dialog>

        {/* delete Dialog */}
        {removeFeature != undefined ? (
          <Dialog
            open={openDeleteDialog}
            onClose={handleEditClose}
            aria-labelledby="form-dialog-title"
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle id="form-dialog-title">Delete Feature</DialogTitle>
            <DialogContent>
              <form noValidate autoComplete="off">
                <div>
                  <TextField
                    margin="dense"
                    id="name"
                    label="Feature Name"
                    type="text"
                    disabled
                    value={removeFeature.name}
                    fullWidth
                  />
                  <TextField
                    margin="dense"
                    id="code"
                    label="Code"
                    type="text"
                    disabled
                    value={removeFeature.code}
                    fullWidth
                  />

                  <DialogContentText
                    color="textPrimary"
                    style={{ marginTop: "18px" }}
                  >
                    {`Are you sure you want to delete ${removeFeature.name}?`}
                  </DialogContentText>
                  <DialogContentText>
                    Please type the following to confirm:
                  </DialogContentText>
                  <DialogContentText>
                    <i>
                      <b>{removeFeature.name}</b>
                    </i>
                  </DialogContentText>
                  <TextField
                    margin="dense"
                    variant="outlined"
                    id="name"
                    type="text"
                    value={deleteConfirmation}
                    onChange={(e) =>
                      setDeleteConfirmation(e.currentTarget.value)
                    }
                    fullWidth
                  />
                </div>
              </form>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleEditClose} color="primary">
                Cancel
              </Button>
              <Button onClick={handleDelete} color="primary">
                {`Delete`}
              </Button>
            </DialogActions>
          </Dialog>
        ) : null}

        {/* Data Grid */}
        <div style={{ height: "80vh" }}>
          <div style={{ display: "flex", height: "100%" }}>
            <div style={{ flexGrow: 1 }}>
              <DataGrid
                pageSize={size}
                rowsPerPageOptions={[10, 20, 30]}
                onPageSizeChange={(size) => {
                  setSize(size);
                  setloadList(true);
                }}
                disableColumnMenu
                density="compact"
                components={{
                  LoadingOverlay: CustomLoadingOverlay,
                  NoRowsOverlay: CustomNoRowsOverlay,
                  Toolbar: CustomToolbar,
                }}
                pagination
                loading={isLoading}
                paginationMode="server"
                rowCount={row}
                filterMode="server"
                onPageChange={(newPage) => {
                  setIndex(++newPage);
                  setloadList(true);
                }}
                rows={featureManagementList}
                columns={headerColumn}
                getRowId={(row) => row.id}
              />
            </div>
          </div>
        </div>
      </MainDrawer>
    </>
  );
};
